<nb-card class="dialog" [nbSpinner]="loading">
    <nb-card-header class="header">
        <morva-icons
                class="close-cross"
                icon="close"
                (click)="close()"
        ></morva-icons>
        <p data-testid="create-datasource-header-text" class="header-text">ورود داده</p>
    </nb-card-header>

    <nb-card-body class="body">

        <section class="connectors">
            <div class="connectors-title">اتصال</div>
            <div class="connectors-box d-flex">
                <div class="col-6 d-flex flex-column justify-content-between">
                    <span (click)="openDataBaseCreateDialog('CreateSqlServer')">Microsoft SQL Server</span>
                    <span (click)="openWebServiceDialog()">Webservice</span>
                    <span (click)="openDataBaseCreateDialog('CreateOracle')">Oracle</span>
                </div>
                <div class="col-6 d-flex flex-column justify-content-between">
                    <span class="disable">MySQL</span>
                    <span class="disable">SQL Server Analysis Services Database</span>
                    <span class="disable">Google Analytics</span>
                </div>
            </div>
        </section>
        <!-- upload files -->
        <section class="uploads">
            <div class="title">فایل</div>
            <div 
                data-testid="data-input-box" 
                class="data-input-box" 
                dragOverClass="drag-over" 
                droppable 
                (filesDropped)="onFileDrop($event)"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.csv,application/json">
                <h6>دادها را در اﯾﻦ ﻗﺴﻤﺖ بکشید و رها ﮐﻨﯿﺪ ﯾﺎ از داﺧﻞ ﺳﯿﺴﺘﻢ ﺧﻮد بارگذاری کنید.</h6>
                <p>فایل‌های csv و Excel Microsoft پشتیبانی می‌شود.</p>
            </div>

            <div class="data-input-url">
                <p>افزودن URL</p>
                <form (submit)="uploadFileFromURL(inputValue)">
                    <input
                            [(ngModel)]="inputValue"
                            name="urlInput"
                            type="url"
                            placeholder="فایل‌های csv و Excel Microsoft پشتیبانی می‌شود.">
                    <button nbButton type="submit" [disabled]="inputValue === ''">بارگذاری</button>
                </form>
            </div>
        </section>
    </nb-card-body>
</nb-card>
